<template>
  <div>
    <!-- 实名认证 -->
    <modalDefault
      :showModal="showModal"
      @close="close()"
      @confirm="confirm()"
      modalText="实名认证"
    >
      <template #dialogContent>
        <div class="update-take-pwd-form">
          <div class="form-item">
            <div class="label">真实姓名</div>
            <div class="input-box">
              <input
                class="input"
                type="text"
                placeholder="请输入真实姓名"
                v-model="Exampleobj.realName"
                placeholder-style="font-size:24rpx;color: #9fafe7"
              />
            </div>
          </div>
          <div class="form-item">
            <div class="label">身份证号</div>
            <div class="input-box">
              <input
                class="input"
                type="text"
                placeholder="请确认身份证号"
                v-model="Exampleobj.idNum"
                placeholder-style="font-size:24rpx;color: #9fafe7"
              />
            </div>
          </div>
        </div>
      </template>
    </modalDefault>
  </div>
</template>
    <script>
import modalDefault from "@/components/common/modalDefault.vue";
export default {
  name: "modalRealName",
  components: {
    modalDefault,
  },
  data() {
    return {
      Exampleobj: {
        realName: "",
        idNum: "",
      },
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      // const userInfo = this.$store.state.USER_INFO;
      // this.Exampleobj.uid = userInfo.userId;
      this.$emit("confirm", this.Exampleobj);
    },
  },
};
</script>
    <style lang="scss" scoped>
.update-take-pwd-form {
  width: 58.67 * 4.2px;
  height: auto;
  min-height: 162.986px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto;
  padding-top: 6.93 * 4.2px;
  padding-bottom: 6.8 * 4.2px;
  text-align: left;
}

.update-take-pwd-form .form-item {
  width: 100%;
  height: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  font-size: 3.33 * 4.2px;
}

.update-take-pwd-form .form-item .label {
  width: 100%;
  height: 7.47 * 4.2px;
  line-height: 7.47 * 4.2px;
  color: #a6bbff;
}

.update-take-pwd-form .form-item .input-box {
  width: 58.4 * 4.2px;
  height: 7.73 * 4.2px;
  background: url("../../assets/images/realNameBtn.png") no-repeat 0 0;
  background-size: 58.4 * 4.2px 7.73 * 4.2px;
}

.user-index
  .take-back-pwd-dialog
  .update-take-pwd-form
  .form-item
  .input-box
  input {
  width: 100%;
  height: 7.73 * 4.2px;
  text-indent: 2.27 * 4.2px;
  background: transparent;
}

.update-take-pwd-form .form-item .error {
  color: #c54646;
}

.user-index
  .take-back-pwd-dialog
  .update-take-pwd-form
  .form-item
  .code-input-box {
  width: 58.4 * 4.2px;
  height: 7.73 * 4.2px;
}

.user-index
  .take-back-pwd-dialog
  .update-take-pwd-form
  .form-item
  .code-input-box
  .code-input {
  width: 37.07 * 4.2px;
  height: 7.73 * 4.2px;
  background: url(data:image/png;base64,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*4.2pxRThVNwYcBkqGS3V1TJ781HYJjRPSzpQS4CZQzE/Vud6WEvcEC3itVzZhQX5/RCBFk/THGW9Bb7yn+xZS4gWSBrRNhapOQRfbvFhn0hqiTsk3FUMym+fBdj7RGEZLbk+7SqWSm+2hoDbZ6SXiJyWVOqMWw5tRFltrSUqrYVSXbjxwg2WmOyJhSxf96DldhVzAFqCzINQlAMujGOFvNJCaMn1oqWXZy0hjhbzpOXWFmXg4Dre+RZWwLjOQwWZOdSZc+4ftn*4.2pxHTbNpXk99uM6l7tcqW9atMQ4fxqEemGdnkulBYt49M/12J+JFe5ktWQYp7i3JZSls34ZVruAe6RQPz2HvrQf2EcKU0HB4t/Ykt3Vl8U5R7ggKy8mmpXWzeu/XMT2EuCcQIWeV+blEH30B57j8LA4FxLsQSMrbyfiZUrZV19//MG7vRcIDuZqYtQXzvn2VMj5Uw9PRIaWFNlpTj6J1FiZE9dun615f+Xaz2O1nMt4h7nhX87Tb+aZF/Mo9/JGOe/ladfyZjOu5U1y38rDOG/mqVfztMt5GPJWHr6WRzBRxbyUNxHFimoFX+FcVb/212FDMdOnTx/k4gQn7jcMQh8baqNO5SXMlZiHMHfrvIx4BXG1ybJly+7SeR3xGuJUJzfo3GRwj86TGhdbvIq42eBenUMoPKfSX+ffET9psWJc+F3387ymyXuq4FdP6B+drHK9wVUmJzo518YpDh7GHO5my5YbMdfYeMLiDcTRNvZncBxBP52tK7YtjdvuQZf9mVjestt2ZT+E8Z3F7tuZluWJZuzjP10RZz4XBBCbAAAAAElFTkSuQmCC)
    no-repeat 0 0;
  background-size: 37.07 * 4.2px 7.73 * 4.2px;
  float: left;
}

.user-index
  .take-back-pwd-dialog
  .update-take-pwd-form
  .form-item
  .code-input-box
  .code-input
  input {
  width: 100%;
  height: 7.73 * 4.2px;
  text-indent: 2.27 * 4.2px;
  background: transparent;
}

.user-index
  .take-back-pwd-dialog
  .update-take-pwd-form
  .form-item
  .code-input-box
  .get-code-btn {
  width: 20.13 * 4.2px;
  height: 7.6 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJcAAAA5CAMAAAAMV0nVAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURYau/3+l+IOs/4eu/4aw/460/3qf8oat/QAAAIet/Yas/o25/4mq/4aw/4Gn+oe1/4at/oew/4iw/4Kq+oqw/4Cz/3SW6oOq+4Kn+IOq+oOo+Yeq/4Ko+X6i9oSs/YKo+YWv/4at/xIgTRglURooUxknUxgmUhckUBspVBMhUCErhhIgThMgTxYjUBUiVxklZxcjXhYjWhsmbRgkYxQiVR4oeRMhTlFowRwncllyyhMhUhombCItch4oeBUiWCMufRglWRMhUSYvihUjTxQhVB8qfxYjWxsnaBcjXxgkYhklaB8pfxwncSUvgyEtbRckURckVxwpVyIshhYkUiAsaRspVRgkZB8sZSArfxYkUx4rYVFnwBUjUhYkVBglUx0oclZwyBQiTx8peRwncxclUhMhThQhUiItdxYkUBooVBspVh4rXx4pcxsmbhQiTiAqgBsnbR0obR8qeh0rXBQiTxonZBYjVhwqWBMhTRglXBkmXxckXxkmYCErgBYjURckWxklXR0rWhwqWyUviSAqfyIudx0qXhYjXFJpwxomaRonXBooWBkmVVdwySIrhx0odBclURUiUBomYxonVh0obhklaSErhCErghknUhkmVhckWRkmVx8rbR4pdSIrhiMsixUjURolaBckYB4peSQuhSIriSMtiB0qWBsnYFdwyx0pYCQtjxglVBsnWhomWRglZRsnbyYwjR8pfSgxlRwoYxsmZRQiVh0payYulllzzSMsjlJpxiUulVhxzCIriCcwkBklZB8qaBwpYRsoXRgkYR0odSQuglJoxSkxmBQhVR4qZBspWxYjWBombSArdyAqfR4peCEsfCAqeyUtkiQtjRonUxwoZh4pcSErhyQugB4peycwkx4qcBkmWx4qZyMufB4peh0oaB0pYxsoahomYSgxmCUukRonVx4raiEsdFt10BglVx0qZSArcSIteh4qaSUujDlIqyMtghwnZyArdWWC2iw2nG6N4zA8oDtKrkZZuRIgT1BmwzdEqFRsyVVuylR4A0wAAAAidFJOU3jzBT+HAviJAHlQBxIazgxZOEWbKwr9ubeiuSTe4nLlZolkof+9AAAMZ0lEQVRo3s2aeVRTVx7HUYvV6b7OvoFJAInsZ6gUBMGoKTYiaqFFaAhBUCDKHC2KgCMUimLAsqpgWIRSQWURRAVFAUVhVISquAC1KNaty9hlus59793f7yZ9KZ0/+z16jvmc33358Ls3L7x7tZjCx3KSxa8jkywFIQtB65kJdw4dOtTW9v5Wkjff3PoS5k0IY1vHQWbZS78wlHvT99va2g4dujPhGUvmZfn8X7/p7u6+WnPYYDBUHr18OXU2TWqVHY2eMUB2VeOWIatCVrVLzPSXLx+tJO97+FbjzZs3v/nTHy3R64knv+vubrw6UKkvKCjU6XRJCyAng+bQIDuZhOgksM/NsKQ0itI+x8thWRAbquNSWFCg//TY*4.2pxJ26sknwOvxPxwiVsc+tSvUpTU0XBkZ6ZtFM9znRhOOrK8CWDygWRfEZcPxWMaGhgO7MAyMlFWMXGloSNPtTq3nzO789nHB66nff9HdeKx+9iJdwxVPz65sTfbyt2mWZ7sL0cQgekiRe9hDZDHASnDowzAYimVvP9SIGFem0WR3eXr2DS5InV1/rLH7i+ee4ryeevSrL4lW6u5zVzy7NP51dbF5L0PuO9PEXkOUB4yVXVtF0aprjOHQ+8hizQzlWV2dv+bs8OACrmWNX3419YUpFo/95cWvG6/Wpy4Y9Oxy93f2yMzMLH6VpvgjB5q5yA4qKSo7OF5Z8VxgB9nQMhNW/GpxcfFcpYNSWZaZ6VH38fIHswZ3p356rPHrF//2mMWzk7/v5rXCs4lVvoNDe9NiyHEXyEVAn1wE1HQc2FC7qGzxRWDtQ8iaoGzN0HEaOrSdqN5/+ePlw0Ss/lbr95OftZh6hyyu2bsH+4hWpkO7S2fngddo7h1wpEm8AexGIkXzRgG9hmUbsOzMKLDRMzi0HFj1GcgGcm2S8k6X28XF93mx2Yb+1h8fsZh6iG/XrBJ/j7L9Lp3kbV+H7FnnJESxEVkHRU4p1Vi2EcrWnwBWnQKsg7xauZL7u1EBbM9Kmj1cmUKhyHAcHTq+mBMjU1lZ03qE8yLtWjD4wN+5bP/8REeF0zoYtLJjBk3vZkQ7gHmnA9vcKypLv+5F2Y6OdBqjoci8uTIvEqc9Z+4N3SZiD2Yl2Rn6eS/SrsHhh86ZRCvDyau35580mxa60qzdBGwvINctWHYX0EIydNMm8mfT3rXAdvZsotmJQ/cB6sGyHel7Xr83tLj45eV9DYWVNbwXt7oehHk4uCRm9M5oXvsvyJZIyF1Aby0DtGwLsDE/YNvfgmzHoWPI2NAxcdm+np70E2eGbt//uOSKTn9Y8CKr62xs/v5OR6cZrn4736MJqLWlCckNoCzXhyKf4ACaFawsC1kIsOA*4.2pxLKQ1a6AhMDlIse29HSk37j3SfF9jVuanYH3qk89ORzDtUvh1ewXGfCecOmA6G32NKV4oQhA27IASbAsMBpYqC2w0CU8WLJkiQqQOjSaphbLgnO3bOlJ30Malufv2VBgeEfwIqs+04Frl19kcAB3ES7S6TT2EZQskaiByW2ARWhFZdEqKFNLbGxseAc2NFkCXsmApodGk4b1pN8Yuu1R19VQyHu9VL978Gxd5v7yDK5duSuW2PCZ5mtFo55mQ2MNSJsDaJocmO8HwKRqYLIPptFEaYFJARUhipNE5waQhp2492F+XfaIrlLwWjCrKza/nfcKBi0bHJUgQwemig7WePEook8dEkDfGhw+QNW4ImCyBNSXSLK4FXbiXlN+rKZCd5T3mr27TxObv5TziszCdkVhb4qwD3ihKFTFsjh0KEIHX3Rg+jIJeSnhgmVaKfHK5bwOLCVebrrL1Cue91J4ufqNgZcEL+QrdtBKoTXMQY5TloOdzsF2Yae1ERIao05LwGt0qTKW+0DyXqmfV2hilUvJx9G1NoB6ReewC6EDU52Gc8FWHDrgilMLS4m8qzQOh0rBC1UTpILX3o7q8qVKZ43bHOqV5MZ5zSO3ibEAXotcTM1WPfZB7FDk+xMHbsrQIQod5KyFgKRaU9Xcsb0d6+e5KJ3d0SsIvBZuWREdL*4.2pxcfxiZ2MHXzJRFSaBdbLaZA1v1TBWQlbVUKpVkZY3t3ZwieL0ieFXNcdM48177wIs5aNnSxU9ZFKoaTZnYgU2ZTGvcQikf7Ko6AryuK4jXv9FLD169PeDFPnm+Yoc4KVky/LphUyYHBYnK6JMHquynzJHSMFW5FLx2mHrZgdd19GLLGT/9RusBHcxNmS+7cRQVFfEOOWyoNXip2UKxJpGG1m7f1wteu0y8Ujo4L+7ixnfi8RzU4mnMMe0DH1S1kgFiNwk1p2UdQbwWeoGXnvPaCl4biVduFn9xK7acwSFO7KBiqx4dcLa1KrGDNseahq16GXo1g9ecKhOvavAyWg/MAVEUrFzjKUMHpo9MzloIWkw1Lge8ak+DV5CJVzl6WSeIlpKRKr6fyugOBMGvRr6FggP7vpGBli97B2trQmURgaEh6JVk4jV6ArzYXJhZD75mpoyVsRsVOrDfJNQ4jXFsocj4qAKDI8GrwsSr/UB1x96x7VlkkliTx3UwnbKfOPjilKGqlZxz5SyMVGXgFTITvOJNvJrQS2YlWs7GHx+cMqtxHLRRgFQiB5nMWJV6hfiAV9gF8ErjvocugleEWryU2E1CbsYBp4zdLHEaZb6shaAlNyoDr2QfOo/OMfFJ9D6hI16ZQ+CFX4301mKyHrQqM8sGy9ivCOjAVBlj9zO1nCZ5G3itQq/LnNdHHwpeoRG+ZvogVlWpxS2UMX05OjD9KFG7pssxap9IV+JFfv8qgfV1WVehqTtIvDbv25kVqkpg0yjqg5GDeC6MHZDFiXvD2hXHtOx5r8SlyroSWF9HdSMaf/RKthLdBU0cBMLmIsHMctbilLHZZg6oOt0XVbW8V0b50kz/kguFglel7krXJfSynW6ylPjGi5dI1C9PmdCHBHG72NcSELn6W1ufyGbi1f4R8zIUNpRcWs2tr837tofafwuPiCqaKHz0s5cBk9vjIyIgFZZptyXTsDKtHBiWTUdVub297Uy/5t6Mzv0Hr5WcE54f3zcUNIQ/vHawqXr9de+75GmdPgOrAmmS7fEpG5AKH7LtSwMDQ/gk49OzbWkITSkbCqQUy+zlpUKSt9nazuSWl+N8h9WXzgcJz9ttBru0C8TrPweqN16/6xdJ9wxKQyGlsLFgG8i/Dg4ODtlmixsVENx/sA1BxoaGwI/EkA+ySB+iNcMpo9xlbl5MeNCiAW5/ou2wvrDvLJnIpurqzd6usDuzrJZmWaSPkJkhyyDBMymLDEYWggwRDvUhQ6lq5Exk/Gu+LJJokU/jfAcyjReS9IJXTeWipPiYa9zKX6/wmsHvR51uXghZ60dzei0yV2CurMwcOw1srZkyI+ba7NWrcOxsn7s65*4.2px5uv/V1j9QldR3NiaPzOSoo6KX276b4bXDm2ZHL+4aeiMD5GWO4VBvNhRZr5cR2yGEvGGvU0ZiZ7tylT+5qy4S9gvbWmsMBUHxJZeI2LvliY4ZCoXCSbERg7uiKYhg89RJsQ6jwI1XRClmGCJFSsq6FCEKRUaGY/n8dqVHHteuqoFWwat/QF8YFM6JcfvR5YmJiY6JGyCJuCe9wQxbD0FkjiVyLJHPPMYg87j96PkuDmUedTHnL5B23WrhvO60tNwy6AvPcWIe+Q77+R31NU181jStmU/j0r4G0j4eY8iIvQtxmW+Gubi073dQZjr7c1oFlTWtLT88YjFpwjctZCYXFQbFnw3jzjvyy5TKsrkYOKJQMoTHFqysTGmGOYiZuTKlUpmf6eFc51/Caw30t3w2+VmLiZP+/F0jESNT2SecD3HnN3l5q4Ws8qBxXr36p8hjFSJnxjAe4zEkq/kzpDp/92zP+HOg9fRjFlMmPv/knZv9RKwAztM0mhhImD+Ne9jPsTAu7oxhkI2LuGM3TXZXl+fIOV3hLtDizvksn/jdF1+23how8OePV0Yq3CriacLDPSHhwmvy9zxjEDfP8dh5QBVGqIKGO43kDyCJ1VFDTX/Lfyf/ZiI9r338ua++biEtq9QXFPLntZCgVzBBkDREacjmiNkvlGFemZMmHNjqKw0Dt1qpFj13f2Hq5M9aWvvhfFuv1y8SgkfZuxZB8IjaDhErs/tZtIuEXQ3DvRIOuAdq+ltbQIt6TZn49IQfT3F55x8meYPGDHpj/LL/cyj++51Tp44cOfLDBEELvKZYPvP3R38Ngf8/8T9SEE8LhbBHXQAAAABJRU5ErkJggg==)
    no-repeat 0 0;
  background-size: 20.13 * 4.2px 7.6 * 4.2px;
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #9fb3f5;
  margin-left: 0.87 * 4.2px;
}

.update-take-pwd-form .form-item .tip-box {
  width: 100%;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  font-size: 2.67 * 4.2px;
  color: #f641a2;
}
.input-box .input {
  width: 100%;
  height: 32.466px;
  line-height: 32.466px;
  text-align: left;
  background: transparent;
  font-size: 3.33 * 4.2px;
  padding-left: 8px;
  box-sizing: border-box;
}

.input-box .input::-webkit-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.input-box .input::-moz-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.input-box .input::-ms-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.input-box .input::placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

</style>